/*
 * FarmSteady — PDP reviews masonry + batched load-more.
 *
 * Server renders a flat list of cards. This script:
 *   - sorts cards: 5-star-with-photo first, then by score
 *   - lays them out as true masonry: each card goes into whichever column
 *     is currently shortest, so a tall photo card never strands a column
 *   - shows two rows initially (4 cards / 2 cols mobile, 6 / 3 cols desktop)
 *   - "Show more" reveals the next batch only (not everything) — new cards
 *     append into the existing columns so on-screen cards don't reshuffle
 *   - rebuilds layout on viewport resize across the column-count breakpoint
 */
(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 990px)';

  function priorityScore(item) {
    var rating = parseInt(item.dataset.rating || '0', 10);
    var hasPhoto = item.dataset.hasPhoto === 'true';
    if (rating === 5 && hasPhoto) return 100;
    if (hasPhoto) return 50 + rating * 5;
    if (rating === 5) return 60;
    return rating * 10;
  }

  function init(section) {
    var grid = section.querySelector('[data-reviews-grid]');
    var expandBtn = section.querySelector('[data-reviews-expand]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(
      grid.querySelectorAll('.fs-reviews-pdp__item')
    );
    if (!cards.length) return;

    cards.sort(function (a, b) {
      return priorityScore(b) - priorityScore(a);
    });

    var container = grid;   // current DOM node holding the layout
    var cols = [];
    var shownCount = 0;
    var lastColCount = 0;

    function colCountNow() {
      return window.matchMedia(DESKTOP_MQ).matches ? 3 : 2;
    }

    // Append cards into whichever column is currently shortest.
    function placeCards(list) {
      list.forEach(function (card) {
        var shortest = cols[0];
        for (var c = 1; c < cols.length; c++) {
          if (cols[c].offsetHeight < shortest.offsetHeight) {
            shortest = cols[c];
          }
        }
        shortest.appendChild(card);
      });
    }

    function buildColumns(colCount) {
      var masonry = document.createElement('div');
      masonry.className = 'fs-reviews-pdp__masonry';
      cols = [];
      for (var i = 0; i < colCount; i++) {
        var col = document.createElement('div');
        col.className = 'fs-reviews-pdp__col';
        cols.push(col);
        masonry.appendChild(col);
      }
      container.replaceWith(masonry);
      container = masonry;
    }

    function updateButton() {
      if (expandBtn) expandBtn.hidden = shownCount >= cards.length;
    }

    // Full (re)build — used on load and on resize across the breakpoint.
    function fullRender() {
      var colCount = colCountNow();
      lastColCount = colCount;
      if (shownCount === 0) shownCount = colCount * 2;
      buildColumns(colCount);
      placeCards(cards.slice(0, shownCount));
      updateButton();
    }

    // Reveal the next batch — append only, no reshuffle of shown cards.
    function showMore() {
      var batch = colCountNow() * 2;
      var prev = shownCount;
      shownCount = Math.min(cards.length, shownCount + batch);
      placeCards(cards.slice(prev, shownCount));
      updateButton();
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', showMore);
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (colCountNow() !== lastColCount) fullRender();
      }, 150);
    });

    fullRender();
  }

  function boot() {
    document.querySelectorAll('.fs-reviews-pdp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
